import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import measuretext from "../../../../assets/images/docs/measuretext.jpg";
import * as React from 'react';
export default {
  BlogMidCTA,
  measuretext,
  React
};